export function getAvailabilityBehaviors() {
  return [
    'date_time_based',
    'after_ticket_sold_out',
    'after_ticket_sale_ends',
    'after_ticket_ends_or_sold_out',
  ];
}

export function getSoldOutBehaviours() {
  return ['after_ticket_sold_out', 'after_ticket_ends_or_sold_out'];
}

export function hasValidAvailabilityBehavior(ticketType, ticketGroup) {
  const availabilityBehaviors = getAvailabilityBehaviors();

  return (
    availabilityBehaviors.includes(ticketType?.availabilityBehavior) ||
    availabilityBehaviors.includes(ticketGroup?.availabilityBehavior)
  );
}

export function shouldShowForRegularBehavior(isCanceled, isSoldOut, isUnavailable, ticketType) {
  const soldOutBehaviours = getSoldOutBehaviours();

  return (
    !isCanceled &&
    !isSoldOut &&
    !isUnavailable &&
    !soldOutBehaviours.includes(ticketType?.availabilityBehavior)
  );
}

export function shouldShowForSoldOutBehavior(isOnSale, ticketType) {
  const soldOutBehaviours = getSoldOutBehaviours();

  return isOnSale && soldOutBehaviours.includes(ticketType?.availabilityBehavior);
}

export function shouldShowTicketSaleDates(
  ticketType,
  ticketGroup,
  isCanceled,
  isSoldOut,
  isUnavailable,
  isOnSale,
) {
  const hasValidBehavior = hasValidAvailabilityBehavior(ticketType, ticketGroup);
  const showForRegular = shouldShowForRegularBehavior(
    isCanceled,
    isSoldOut,
    isUnavailable,
    ticketType,
  );
  const showForSoldOut = shouldShowForSoldOutBehavior(isOnSale, ticketType);

  return hasValidBehavior && ticketType?.showTicketSaleDates && (showForRegular || showForSoldOut);
}
